import type { CollaborationPresenceUser } from '@/lib/collaboration-presence';
import type { Dispatch, SetStateAction } from 'react';

export function arePresenceUsersEqual(a: CollaborationPresenceUser[], b: CollaborationPresenceUser[]): boolean {
    if (a.length !== b.length) {
        return false;
    }

    return a.every((user, index) => {
        const other = b[index];
        return (
            user.clientId === other.clientId && user.name === other.name && user.color === other.color && user.initials === other.initials
        );
    });
}

export function setPresenceUsersIfChanged(
    setUsers: Dispatch<SetStateAction<CollaborationPresenceUser[]>>,
    next: CollaborationPresenceUser[],
): void {
    setUsers(prev => (arePresenceUsersEqual(prev, next) ? prev : next));
}
